/**
 * PROJECTS一覧ページの表示
 */
import ResizeWatch from '../utils/ResizeWatch';
//import ScrollWatch from '../utils/ScrollWatch';
import AnyStore from '../common/AnyStore';
import PageTransition from '../common/PageTransition';
import Vue from 'vue/dist/vue.min.js'

export default class projectsShowList {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'projectsShowList';
    this.isStart = false;

    this.init();
  }

  /**
   * 表示前
   */
  init() {
    // スクロールイベント
    Vue.directive('scroll', {
      inserted: function (el, binding) {
        let f = function (evt) {
          if (binding.value(evt, el)) {
            window.removeEventListener('resize', f);
            window.removeEventListener('scroll', f);
          }
        };
        window.addEventListener('resize', f);
        window.addEventListener('scroll', f);
      }
    });

    // projectsリンク
    Vue.component('project-block', {
      data: function() {
        return {
          isShow: false,
          isImgLoad: false
        }
      },
      methods: {
        sandwitch: function(text) {
          return '（' + text + '）';
        },
        handleScroll: function(e, el) {
          if (!this.isImgLoad) return;
          if (this.isShow) return;

          const posY = AnyStore.getScrollTop() + (window.innerHeight * 0.8);
          if (posY > AnyStore.getOffsetTop(el).top) {
            requestAnimationFrame(this.handleScrollDelay.bind(this, [el]));
            return true;
          }
        },
        handleScrollDelay: function(el) {
            this.isShow = true;
            this.showBlock(el[0]);
        },
        imgLoaded: function(e, index) {
          this.isImgLoad = true;
          this.$emit('child-loaded', index);
          this.handleScroll(null, this.$el)
        },
        showBlock: function(el) {
          let delay = 0;
          if (AnyStore.setDevice() === 'pc') {
            delay = 0.1 * (this.index % 3);
          }

          // 表示
          TweenMax.fromTo(el, 1.0, {
            y: '50%',
            opacity: 0,
            visibility: 'visible'
          }, {
            y: '0%',
            delay: delay,
            opacity: 1,
            ease: Cubic.easeInOut
          });

          TweenMax.fromTo(el.querySelector('.project-thumb__img'), 0.9, {
            scale: 1.3,
            y: '110%'
          }, {
            scale: 1,
            y: '0%',
            delay: 0.1 + delay,
            clearProps: 'all',
            ease: Cubic.easeOut,
            onComplete: this.showBlockComp.bind(this)
          });

          TweenMax.fromTo(el.querySelector('.title-main'), 0.7, {
            opacity: 0,
            y: 60
          }, {
            opacity: 1,
            y: 0,
            delay: 0.4 + delay,
            clearProps: 'all',
            ease: Cubic.easeOut
          });

          TweenMax.fromTo(el.querySelector('.title-cate'), 0.6, {
            opacity: 0,
            y: 40
          }, {
            opacity: 1,
            y: 0,
            delay: 0.5 + delay,
            clearProps: 'all',
            ease: Cubic.easeOut
          });
        },
        showBlockComp: function() {
          TweenMax.set(this.$el, {className: '+=is-show'});
        }
      },
      props: ['prj', 'index'],
      template: '<li class="p-projects-archive" v-scroll="handleScroll">\n' +
        '        <a :href="prj.url">\n' +
        '          <div class="p-projects-archive__wrap">\n' +
        '            <div class="project-thumb">\n' +
        '              <img class="project-thumb__img" :src="prj.image" alt="" @load="imgLoaded($event, index)">\n' +
        '            </div>\n' +
        '            <h2 class="title-main">\n' +
        '              <span v-html="prj.title"></span>\n' +
        '              <span v-if="prj.sub_title" v-html="sandwitch(prj.sub_title)"></span>\n' +
        '            </h2>\n' +
        '            <h3 class="title-cate" v-html="prj.cate"></h3>\n' +
        '          </div>\n' +
        '        </a>\n' +
        '      </li>'
    });

    // projects一覧を生成
    this.vue = new Vue({
      el: '#vue-projects',
      data: {
        isStart: false,
        isOver: false,
        isImgLoad: false,
        loadedCount: 0,
        counter: 0,
        perCount: 15,
        baseProjects: [],
        projects: []
      },
      computed: {
        checkMore: () => {
          return function() {
            return (this.isOver) ? 'is-hide' : '';
          }
        }
      },
      methods: {
        start: function() {
          this.isStart = true;
        },
        imgLoaded: function(index) {
          this.loadedCount++;

          if (this.counter === this.loadedCount) {
            this.isImgLoad = false;
            this.$nextTick(function () {
              // 一覧の表示スタート：スクロールチェック
            });
          }
        },
        addProjects: function() {
          if (this.isOver) return;
          if (this.isImgLoad) return;
          this.isImgLoad = true;

          // 一覧のローディング中の表示：moreボタンに変化？
          let i = this.counter;
          let max = this.counter + this.perCount;

          for (; i < max; i++) {
            if (!this.baseProjects[i]) break;
            this.$set(this.projects, i, this.baseProjects[i]);
            this.counter++;
          }
          if (this.counter === this.baseProjects.length) {
            // 全て表示
            this.isOver = true;
            // MOREボタンを消す
            TweenMax.to(this.$refs['p-link-more'], 1.0, {
              display: 'none',
              opacity: 0,
              ease: Cubic.easeOut
            });
          }
        },
        btnMore: function(e) {
          // 一覧の追加
          this.addProjects();
        }
      },
      created: function() {
        this.baseProjects = JSON.parse(document.getElementById('js-param-projects').textContent);
      },
      mounted: function() {
        // 初期一覧
        this.addProjects();
      }
    });

    this.PageTransition = new PageTransition();

    this.openObject = [];
    this.scrollObject = [];

    // トランジション時のコールバック
    // start
    this.PageTransition.on('TRANSITION_OUT',  this.transitionOut.bind(this));
    // next
    this.PageTransition.on('TRANSITION_IN', this.transitionIn.bind(this));

    // イベント
    this.resizeUpdate();
    ResizeWatch.registerObserver(this.name, this);
  }

  /**
   * 表示時
   */
  start() {
    // 前面のレイヤーを上に移動する
    this.PageTransition.transitionOut();
  }

  /**
   * 表示アニメ
   */
  transitionOut() {

  }

  transitionOutComp() {
    this.isStart = true;
  }

  /**
   * 非表示時アニメ
   */
  transitionIn() {

  }

  /**
   * リサイズ
   */
  resizeUpdate() {
    //this.scrollUpdate(AnyStore.getScrollTop());
  }
}
